import { createSlice } from "@reduxjs/toolkit";
import StorageService from "utils/StorageServices";


const initialState = {
  filters: {
    company_id: StorageService.getCompanyId(),
    consignor_id: "",
    supplier_id: "",
    driver_id: "",
    vehicle_ownership: 0,
    from_location: "",
    to_location: "",
    branch_id: "",
    start_date: "",
    end_date: "",
    limit: 25,
    offset: 1,
    search: "",
    trip_status: 0,
    responses: 0,
    vehicle_id: "",
  },
};

const TripFilterSlice = createSlice({
  name: "tripFilter",
  initialState,
  reducers: {
    updateInputValue: (state, action) => {
      state.filters = action.payload;
    },
  },

  reducers: {
    setTripFilter: (state, action) => {
      // replace entire filter (useful for reset or API sync)
      return { ...state, ...action.payload };
    },
    resetTripFilter: () => initialState,
    updateTripFilterField: (state, action) => {
      // payload => { key: "search", value: "truck" }
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
});

export const { setTripFilter, resetTripFilter, updateTripFilterField } = TripFilterSlice.actions;
export default TripFilterSlice.reducer;
